import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA support
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('PWA: İçerik önbelleğe alındı, offline çalışmaya hazır.');
  },
  onUpdate: (registration) => {
    console.log('PWA: Yeni versiyon mevcut, sayfa yenilenince güncellenecek.');
    // Optionally show update notification to user
    if (window.confirm('Yeni bir versiyon mevcut. Güncellemek için sayfayı yenilemek ister misiniz?')) {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
      window.location.reload();
    }
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
